import type { RouteRecordRaw } from "vue-router"

const routes: RouteRecordRaw[] = [
  {
    name: "internal.version",
    path: "/internal/version",
    component: () => import("@/views/internal/VersionView.vue"),
    meta: {
      public: true,
      hideStepper: true,
    },
  },
]

export default routes
